import { ref, Ref } from "@nuxtjs/composition-api";
import { postApiAxios } from "~/helpers";
import api from "~/config/extensionsApi";
import { UseLoyaltyInterface, LoyaltyHistoryResponse } from "./useLoyalty";

export function useLoyalty(): UseLoyaltyInterface {
  const loading = ref<boolean>(false);
  const loyaltyHistory = ref<LoyaltyHistoryResponse | null>(null);

  async function load(params: { loyalty_card: string; limit: number; offset: number }): Promise<void> {
    try {
      loading.value = true;
      const response = await postApiAxios(api.erp.loyalty_history_by_code, params);
      loyaltyHistory.value = response;
    } catch (error) {
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    loyaltyHistory,
    load,
  };
}
